require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.reduce.js");
var isClient = require('./isClient');
function Storage(_ref) {
  var storage = _ref.storage,
    getPrefix = _ref.getPrefix,
    prefix = _ref.prefix;
  var inMemoryStorage = {};
  function isStorageSupported() {
    try {
      var testKey = 'key';
      storage.setItem(testKey, testKey);
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }
  function clear() {
    if (isStorageSupported()) {
      storage.clear();
    } else {
      inMemoryStorage = {};
    }
  }
  function getItem(name) {
    if (isStorageSupported()) {
      var value = storage.getItem(getPrefix(name));
      return value ? JSON.parse(value) : null;
    } else {
      if (inMemoryStorage.hasOwnProperty(name)) {
        return inMemoryStorage[name];
      }
      return new Error("property '" + getPrefix(name) + "-" + name + "' not found");
    }
  }
  function key(index) {
    if (isStorageSupported()) {
      return storage.key(index);
    } else {
      return Object.keys(inMemoryStorage)[index];
    }
  }
  function removeItem(name) {
    if (isStorageSupported()) {
      storage.removeItem(getPrefix(name));
    } else {
      delete inMemoryStorage[name];
    }
  }
  function setItem(name, value) {
    if (isStorageSupported()) {
      var namePrefixed = getPrefix(name);
      storage.setItem(namePrefixed, JSON.stringify(value));
    } else {
      inMemoryStorage[name] = JSON.stringify(value);
      return new Error('Saved on storage fallback');
    }
  }
  function clearWithPrefix() {
    if (isStorageSupported()) {
      var allItemsStorage = Object.assign({}, localStorage);
      var allKeysItemsStorage = Object.keys(allItemsStorage);
      var itemsWithoutKey = allKeysItemsStorage.reduce(function (acc, curr) {
        var _Object$assign;
        return curr.includes(prefix) ? acc : Object.assign({}, acc, (_Object$assign = {}, _Object$assign[curr] = allItemsStorage[curr], _Object$assign));
      }, {});
      storage.clear();
      Object.entries(itemsWithoutKey).forEach(function (_ref2) {
        var key = _ref2[0],
          value = _ref2[1];
        return localStorage.setItem(key, value);
      });
    }
  }
  return {
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    key: key,
    getLength: function getLength() {
      return storage.length;
    },
    clearWithPrefix: clearWithPrefix
  };
}
function createStorage(_ref3) {
  var _ref3$prefix = _ref3.prefix,
    prefix = _ref3$prefix === void 0 ? 'safe' : _ref3$prefix;
  var getPrefix = function getPrefix(name) {
    return prefix + "-" + name;
  };
  return {
    local: Storage({
      storage: isClient() ? window.localStorage : {},
      getPrefix: getPrefix,
      prefix: prefix
    }),
    session: Storage({
      storage: isClient() ? window.sessionStorage : {},
      getPrefix: getPrefix,
      prefix: prefix
    })
  };
}
module.exports = createStorage;